import makeTable from "./makeTable";

const settingsFinancesExecutorPenaltiesModalManualFines = makeTable({
	allIds: ["name", "balance"],
	i18tPath: (id) => `settings.finances.executorPenalties.columns.${id}`,
	defaultIds: ["name", "balance"],
	initialSortMethod: {
		column: "name",
		type: "asc",
	},
	initialWidths: {
		name: 300,
		balance: 300,
	},
	initialResizable: {
		name: true,
		balance: true,
	},
	initialSortable: {
		name: true,
		balance: true,
	},
});

export default settingsFinancesExecutorPenaltiesModalManualFines;
